// extracted by mini-css-extract-plugin
export default {"avatar":"UserInfo_avatar__3vtyM","avatarTitle":"UserInfo_avatarTitle__ytlBk","googleIcon":"UserInfo_googleIcon__kze0T"};